export const translations = {
  'es-419': {
    translation: {
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      firstName: 'Nombre',
      lastName: 'Apellido',
      name: 'Nombre',
      role: 'Rol',
      status: 'Estado',
      email: 'Correo electrónico',
      phone: 'teléfono',
      type: 'Tipo',
      details: 'Detalles',
      nodes: 'Nodos',
      roles: 'Roles',
      cancel: 'Cancelar',
      submit: 'enviar',
      delete: 'Eliminar',
      create: 'Crear',
      deleteNodeError: 'Error al eliminar el nodo',
      deleteConfirmation: '¿Confirma que desea eliminar?',
      warning: 'Advertencia',
      Alert: 'Alerta',
      deleteSure: 'Sí, estoy seguro',
      nodesWillBeCreatedAt: 'Los nodos se crearán en',
      searchFor: 'Buscar',
      rolesError: 'Error al obtener la lista de funciones',
      userListError: 'Error al obtener la lista de usuarios',
      organisationListError: 'Error al obtener la lista de organizaciones',
      loadingRoles: 'Cargando funciones...',
      selectRole: 'Seleccionar la función',
      validEmail: 'Ingrese una dirección de correo electrónico válida',
      requiredEmail: 'Se requiere correo electrónico',
      resend: 'Reenviar',
      restrictedDomain: 'Restricted email domain',
      addUserSuccess: 'El usuario se añadió correctamente',
      editUserSuccess: 'El usuario se editó correctamente.',
      deleteUserSuccess: 'Usuario eliminado exitosamente',
      deleteModalAlertMessage:
        'Estás a punto de eliminar al usuario {{userName}}. Todos los permisos para el usuario serán revocados.',
      deleteProceedMessage: '¿Deseas proceder con la eliminación?',
      userAlreadyExist:
        'El usuario ya existe con este ID de correo electrónico.',
      addUserError: 'No se pudo añadir al usuario. Intente otra vez.',
      editUserError: 'No se pudo editar el usuario. Intente otra vez.',
      deleteUserError:
        'No se pudo eliminar al usuario. Por favor, inténtalo de nuevo.',
      nodesError: 'Error al obtener los nodos asignados',
      childNodesError: 'Error al cargar los nodos secundarios',
      hierarchyError: 'Error al obtener la jerarquía',
      requestFailed: 'Se produjo un error en la solicitud',
      emailSentSuccess:
        '¡Correo electrónico de activación enviado exitosamente!',
      activationEmailError:
        'No se pudo enviar el correo electrónico de activación.',
      activationEmailError1:
        'No se pudo enviar el correo electrónico de activación. Inténtelo de nuevo más tarde.',
      allOrganisations: 'Todas las organizaciones',
      address: 'Dirección',
      hierarchyMetaError: 'Error al obtener los detalles de la jerarquía',
      nodeMetaError: 'Error al cargar los detalles del nodo',
      contactName: 'Nombre del contacto',
      downloadTemplate: 'Descargar la plantilla',
      newOrg: 'Nueva organización',
      save: 'guardar',
      upload: 'cargar',
      uploading: 'Cargando',
      dropExcel: 'Colocar la hoja de Excel, o',
      browse: 'examinar',
      importSettings: 'Importar ajustes',
      addNodesSites: 'Añadir nuevos nodos/sitios',
      updateNodesSites:
        'Actualizar la información de los nodos/sitios existentes',
      disableNodesSites: 'Desactivar los nodos/sitios que ya no existen',
      disabled: 'Desactivado',
      new: 'Nuevo',
      updated: 'Actualizado',
      siteInstallation: 'Sitios',
      addOrgSuccess: '¡Organización creada con éxito!',
      excelUploadError: 'No se pudo guardar el Excel. Intente otra vez.',
      saveError: 'No se pudo guardar. Intente otra vez más tarde.',
      saveBadRequestError:
        'Error al guardar. Es probable que se trate de un problema con los datos que intentaba guardar.',
      telephone: 'teléfono',
      externalIds: 'identificadores externos',
      contactEmail: 'Correo electrónico de contacto',
      longitude: 'Longitud',
      latitude: 'Latitud',
      primaryContactName: 'nombre del contacto principal',
      primaryContactEmail: 'Correo electrónico de contacto principal',
      templateError:
        'Error al descargar la plantilla. Intente otra vez más tarde',
      templateError1:
        'No se pudo obtener la plantilla. Intente otra vez más tarde',
      home: 'Inicio',
      organisations: 'Organizaciones',
      users: 'Usuarios',
      lightTheme: 'Tema claro',
      darkTheme: 'Tema oscuro',
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      activateUserAcc: 'Activar cuenta de usuario',
      phoneNumber: 'Número de teléfono',
      optional: 'Opcional',
      password: 'Contraseña',
      confirmPassword: 'Confirmar la contraseña',
      endUser: 'Acuerdo de licencia de usuario final',
      iAccept: 'Acepto el Acuerdo de Licencia de Usuario Final.',
      iHereby: 'Por el presente, confirmo que he leído y aceptado el',
      eula: 'CLUF',
      iRead: 'He leído la Política de Privacidad de Honeywell',
      iUnderstood: 'Sí, he leído y comprendido la',
      privacyPolicy: 'Política de privacidad',
      activate: 'activar',
      activationSuccess: 'Éxito de la activación',
      newAccAccess:
        'Para acceder a su nueva cuenta, inicie sesión con su nuevo nombre de usuario. Este nuevo nombre de usuario se muestra a continuación:',
      emailSent:
        'Se ha enviado un nuevo nombre de usuario a su ID de correo electrónico.',
      signin: 'INICIAR SESIÓN',
      activationError: 'Error en la activación',
      pleaseTryAgain: 'Intente otra vez',
      activationExpired: 'Token de activación caducado',
      activationExpiredText:
        'Puede deberse a que el enlace enviado por correo electrónico ha expirado, ya se ha utilizado o es incorrecto. Si el problema persiste, solicite un nuevo correo electrónico de activación.',
      contactSupport: 'Error. Póngase en contacto con el soporte técnico',
      pwdMatch: 'Las contraseñas deben coincidir',
      required: 'Obligatorio',
      eligiblePwd:
        'La contraseña debe contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número, 1 carácter especial y un mínimo de 11 caracteres',
      invalidPhoneNumber: 'Número de teléfono inválido',
      invalidName:
        'El nombre no debe exceder los 255 caracteres ni debe contener espacios iniciales o finales',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'zona horaria',
      timeZone: 'zona horaria',
      commissioningStatus: 'estado de puesta en servicio',
      countryCode: 'código de país',
      childCount: 'recuento de secundarios',
      sheetVersion: 'Versión de la hoja',
      unknownError: 'Error desconocido. Intente otra vez mástarde.',
      preview: 'vista preliminar',
      file: 'Archivo',
      inCompatibleExcel: 'El archivo debe estar en formato .xlsx.',
      selectOrg: 'Seleccionar organización',
      noRecordFound: 'No se encontraron registros',
      total: 'Total',
      items: 'Elementos',
      forbidden: 'Prohibido',
      noPermissionText: 'No tiene permiso para acceder a esta página',
      accessPermission: 'Inicie sesión en una cuenta con permisos de acceso',
      technicianExternalAccessPermission:
        'Por favor, inicia sesión en la aplicación móvil',
      redirectToLogin: 'Redireccionamiento a la página de inicio de sesión',
      errorUserSettings: 'Error al obtener la configuración del usuario',
      invalidSystemGuid: 'Guid del sistema inválida',
      languageNotSupported: 'Idioma no admitido',
      subscriptions: 'Suscripciones',
      gatewayManagement: 'Gestión de puertas de enlace',
      subscriptionNumber: 'Número de suscripción',
      orderNumber: 'Número de pedido',
      bundle: 'Haz',
      activatedOn: 'fecha de activacion',
      order: 'orden',
      editSubscription: 'Editar suscripción',
      noNodeSelected: 'No hay ningún nodo seleccionado',
      noUserSelected: 'Ningún usuario seleccionado',
      loadingBundles: 'Cargando paquetes...',
      bundlesError: 'Error al obtener las paquetes',
      selectBundle: 'Seleccionar la bundle',
      addSubscriptionSuccess: 'Suscripción agregada correctamente',
      addSubscriptionError:
        'No se pudo agregar la suscripción. Inténtalo de nuevo.',
      subscriptionInputValidationError:
        'puede ser un valor alfanumérico con un guión y no debe exceder los 13 caracteres',
      errorUserGlobalPrivileges:
        'Error al obtener los privilegios globales del usuario',
      subscriptionAlreadyExist: 'La suscripción ya existe.',
      invalidSubscription: 'Suscripción inválida',
      Version: 'Versión',
      systemType: 'Tipo de sistema',
      systemId: 'ID del sistema',
      reviewGatewayDetails: 'Revisar los detalles de la puerta de enlace',
      site: 'Sitio',
      Organisation: 'Organización',
      gatewayRegistration: 'Registro de puerta de enlace',
      selectAnOrg: 'Seleccione una organización',
      selectASite: 'Seleccione un sitio',
      register: 'Registrar',
      selectSiteToRegsiter:
        'Seleccione el sitio para registrar la puerta de enlace',
      gatewayRegistrationFailureMsg:
        'No se pudo registrar la puerta de enlace con la plataforma IOT de Honeywell Sentience',
      gatewayRegistrationSuccessMsg:
        'Gateway se ha registrado correctamente con la plataforma IOT de Honeywell Sentience',
      siteEmptyMsg:
        'Todos los sitios de la organización {{- orgName}} ya están registrados',
      forgeOnboarding: 'Mapeo Organizacional',
      SiteFetchingFailure: 'No se pudieron obtener sitios de Forge',
      selectAllSitesText:
        'Seleccione todos los sitios de Forge para la integración en Remote Building Manager',
      onBoardingFailure: 'No se pudo iniciar la incorporación del sitio',
      customerID: 'ID del cliente',
      enterCustomerID: 'Ingrese la ID del cliente',
      loadingSites: 'Cargando sitios...',
      fetchSites: 'RECUPERAR SITIOS',
      subscriptionActivateSuccess:
        'La suscripción para "{{siteName}}" se activó con éxito',
      subscriptionActivateError:
        'No se puede activar debido a un problema técnico, comuníquese con su administrador',
      activateNow: 'Activar ahora',
      multiSiteSuccess: 'Los sitios se agregaron con éxito.',
      onboardSelected: 'Se seleccionó la incorporación',
      sitePartialSuccess:
        'Algunos sitios no pudieron incorporarse debido a problemas técnicos. Vuelva a intentarlo o póngase en contacto con su administrador.',
      confirm: 'Confirmar',
      onboardingFailed: 'Error de incorporación',
      failed: 'Error',
      onboardedSuccessfully: 'Sitio incorporado',
      notOnboarded: 'No incorporado',
      onboarding: 'Incorporando...',
      reOnboard: 'Reincorporación',
      selectAll: 'Seleccionar todo',
      siteSuccess: 'El sitio se agregó con éxito.',
      dataloseWarning:
        'No actualice la página mientras los sitios se están incorporando.',
      addServiceSuccess: 'Servicios añadidos con éxito',
      addServicesText: 'Agregar servicios',
      validityText: 'Período de validez',
      invalidInputError: 'entrada inválida',
      subsactivateError: 'Suscripción ya activada',
      subsnotfoundError: 'Detalles de suscripción no encontrados',
      invalidorderError: 'Número de pedido no válido',
      bundnotfoundError: 'Detalles del paquete no encontrados',
      subscribedServices: 'SERVICIOS SUSCRITO',
      subsactivateSuccess: 'Suscripción creada y activada con éxito',
      subsactivateFailure:
        'Suscripción creada, pero la activación falló. Inténtalo de nuevo !!',
      subsactivateDiffSite: 'Suscripción ya activada para un sitio diferente',
      gatewayAssociation: 'Asociación de la puerta de enlace',
      systemGuid: 'Guid del sistema',
      success: 'Éxito',
      contactSystemAdministrator:
        'Comuníquese con el administrador del sistema',
      siteName: 'Nombre del sitio',
      location: 'Ubicación',
      action: 'Acción',
      addNewSite: 'Agregar nuevo sitio',
      add: 'Agregar',
      sitesAssociated: '{{siteCount}} Sitios Asociados',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Buscar sitios',
      noResultFound: 'No se encontraron resultados',
      noDataFound: 'No se encontraron datos',
      loadMore: 'Cargar más',
      unlinkMessage:
        'Para desvincular {{siteName}} de {{sku}}, comuníquese con el centro de atención al cliente de Honeywell (+01 480-353-3020) o envíe un correo electrónico a support@honeywell.com',
      associatedOrderNumber: 'Número de pedido asociado',
      associatedSubscriptionNumber: 'Número de suscripción asociado',
      helperTextSKU:
        'Para modificar el número de suscripción, póngase en contacto con',
      helperOrderTextSKU:
        'Para modificar el número de pedido, póngase en contacto con',
      customerCare: 'Atención al cliente',
      skuDetails: 'SKU Detalles',
      manageSites: 'Administrar sitios',
      skuName: 'SKU Nombre',
      skuDescription: 'SKU Descripción',
      licenseUtilization: 'Utilización de la licencia',
      validTill: 'Válida hasta',
      editSKU: 'Editar SKU',
      duplicateSiteError: 'El sitio ya está agregado',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: 'Error al obtener la lista de sitios',
      siteSuccessMsg: 'Sitios añadidos correctamente',
      siteFailedMsg: 'Sitios no se pudieron agregar',
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'Nueva suscripción agregada',
      licensesOf: 'Licencias de',
      all: 'Todas',
      orderPlacedBy: 'Pedido realizado por',
      pendingRenewal: 'Renovación pendiente',
      daysRemaining: 'Días restantes',
      renewSubscriptionMessage:
        'Para renovar {{skuName}}, comuníquese con el centro de atención al cliente de Honeywell (+01 480-353-3020) o envíe un correo electrónico a support@honeywell.com',
      columnSelection: 'Selección de columnas',
      selectUpTo: 'Puede seleccionar hasta',
      itemsToDisplay: 'elementos para que se muestren en la tabla.',
      subscriptionManagement: 'Gestión de suscripciones',
      activated: 'Activado',
      warningHeader: '¿Está seguro de que desea cancelar?',
      warningMessage: 'Hay cambios sin guardar que se perderán',
      renewSubscription: 'Renovar la suscripción',
      pendingActivation: 'Pendiente de activación',
      notAuthorizedError:
        'No está autorizado a asignar SKU a esta organización',
      gatewayRegistrationInProgress: '{{gateway}} está en curso',
      gatewayAssociationFailed:
        'Verifique la conectividad de la puerta de enlace y vuelva a intentarlo; si vuelve a fallar, comuníquese con el administrador del sistema.',
      gatewayRegistrationFailed:
        'Pruebe de nuevo. si vuelve a fallar, comuníquese con el administrador del sistema.',
      doAssociationMessage:
        'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: 'Error en el procesamiento de la asociación.',
      association: 'Asociación',
      dataloseWarningForRegistration:
        'El registro de puerta de enlace está en curso y puede tardar unos minutos. Para evitar la pérdida de datos, no actualice la pantalla.',
      dataloseWarningForAssociation:
        'El asociación de puerta de enlace está en curso y puede tardar unos minutos. Para evitar la pérdida de datos, no actualice la pantalla.',
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Unidad',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Plantilla agregada con éxito',
      addTemplateError: 'No se pudo agregar plantilla.Inténtalo de nuevo.',
      updateTemplateSuccess: 'Plantilla actualizada con éxito',
      updateTemplateError:
        'No se pudo actualizar la plantilla.Inténtalo de nuevo.',
      outOfRangeError: 'El valor debe estar entre {{min}} y {{max}}',
      requiredField: 'Por favor llene todos los campos',
      templateName: 'Nombre de la plantilla',
      modelName: 'Nombre del modelo',
      vendorName: 'Nombre del proveedor',
      uniqueValueError: 'El valor debe ser único',
      templateMangement: 'Gestión de plantillas',
      equipmentType: 'Tipo de equipo',
      selectType: 'Seleccionar tipo',
      listOfTemplate: 'Lista de plantilla',
      selectTemplate: 'Seleccionar plantilla',
      ElectricityVoltage: 'Voltaje de electricidad',
      ElectricityCurrent: 'Corriente eléctrica',
      ElectricPowerFactor: 'Factor eléctrico',
      ElectricFrequency: 'Frecuencia eléctrica',
      EnergyReceived: 'Energía recibida',
      ActivePower: 'Poder activo',
      ActivePowerA: 'Potencia activa A',
      ActivePowerB: 'Potencia activa B',
      ActivePowerC: 'Potencia activa C',
      ReactivePower: 'Poder reactivo',
      ApparentPower: 'Poder aparente',
      PeakDemand: 'La demanda máxima',
      ElectricityCurrentA: 'Corriente de electricidad A',
      ElectricityCurrentB: 'Corriente de electricidad B',
      ElectricityCurrentC: 'Corriente de electricidad c',
      ElectricityVoltageA: 'Voltaje de electricidad A',
      ElectricityVoltageB: 'Voltaje de electricidad B',
      ElectricityVoltageC: 'Voltaje de electricidad C',
      ElectricityConsumption: 'Consumo de electricidad',
      loaderWelcomeMessage: 'Bienvenido al Portal de Incorporación. Aguarde.',
      latitudeAndLongitude: 'Latitud & Longitud',
      siteUpdateSuccessMessage:
        'Los datos del sitio se actualizaron correctamente',
      siteUpdateErrorMessage: 'Error al actualizar los detalles del sitio',
      provisioningFailedMessages:
        'Error en el aprovisionamiento del sitio. Pruebe de nuevo',
      onboardAllSites: 'Integrar todos los sitios',
      geoCordinatesErrorMsg: 'Verifique las coordenadas',
      tooltipCordinateMessage: 'Las coordenadas deben estar entre',
      emptyValueMessage: 'Valor vacío no permitido',

      browseFile: 'Browse File',
      fileTypeErrorMsg: 'File type is not allowed',

      orgImgTitle: 'Upload Organization Logo',
      orgImgDropTxt: 'Drag and Drop Logo',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px and Only *.png file format',
      orgImgPreviewTxt: 'Preview Logo',
      orgImgTooltipTxt:
        'Logo to have transparent background and should contrast black header background',
      orgImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb',

      siteImgTitle: 'Upload Site image',
      siteImgDropTxt: 'Drag and Drop Building image (*.png or .jpg)',
      siteImgPreviewTxt: 'Preview Site Details Page',
      siteTooltipTxt:
        'Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px and *.png & *.jpg file format',
      siteImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb',
      orTxt: 'Or',
      addLogo: 'Add Logo',
      addImage: 'Add Image',
      imageUploadSuccess: 'Image Uploaded Successfully',
      alertnteId: 'Nombre de usuario alternativo:',
      username: 'Nombre de usuario:',
      errorFetchingUser: 'Error al obtener la lista de usuarios',
      errorFetchingRoles: 'Error al obtener la lista de funciones',

      gateway: 'GATEWAY',
      associateAndSyncBtn: 'ASOCIAR & SINCRONIZAR',
      cancelBtn: 'CANCELAR',
      guidValidationError: 'Error de validación de GUID',
      gatewayId: 'ID DE GATEWAY',
      addNewGateway: 'Agregar nueva gateway',
      successMessage1: 'Asociación del sitio, completada',
      successMessage2:
        'Asociación del sitio, completada. Se iniciará la sincronización del modelo',
      errorMessage:
        'Asociación fallida, la sincronización del modelo no se iniciará',
      importUsers: 'Importar usuarios',
      importUsersSubHeading:
        'Agregue y administre lo que desea importar descargando la plantilla CSV.',
      dropCsvHere: 'Arrastra y suelta el archivo aquí o',
      browsrForFiles: 'Buscar archivos',
      subHeadingBrowser:
        'Solo se aceptan archivos CSV y el archivo no debe exceder los 5 MB.',
      subHeadingBrowserTwo: '(solo una carga posible a la vez)',
      userUploadSuccess: 'Successfully data sent',
      userUploadProcessing:
        'The data has been successfully uploaded. We are currently processing and will take a few minutes. We will update you soon.',
      fileNameDisplay: 'File Name :',
      fileName: 'File Name',
      errorNotification:
        'We encountered an issue while uploading the template, please rectify below errors and re-upload the template.',
      errorHeading: 'Error',
      slnumber: 'SL NO.',
      errorMessageHeading: 'ERROR MESSAGE',
      endUserAgreement: 'Términos de Honeywell Forge',
      privacyStatement: 'Declaración de Privacidad',
      yourPrivacyChoices: 'Opciones de privacidad',
      cookieNotice: 'Aviso de Cookies',
      dataCentre: 'Centro de datos',
      isForgeText: 'Edificios',
      gatewayIdleMessage:
        'Has estado inactivo durante unos minutos, actualiza la página para continuar.',
      refresh: 'Refrescar',
      landingLogin: 'Haga clic aquí',
      loginUserIntegratorRole: 'Usuarios de comercio electrónico de BA',
      loginUserCustomerRole: 'Todos los demás usuarios',
      loginWelcomeNote:
        'Bienvenido, elija su rol a continuación para comenzar.',
      termsAndConditions: 'Términos y condiciones',
      accept: 'Aceptar',
      legalPatentInformation: 'Información legal de patentes',
      onboardingPortal: 'Portal de incorporación',
      customers: 'Clientes',
      templates: 'Plantillas',
      assetModelling: 'Modelado de activos',
      selectCustomer: 'Seleccionar cliente',
      integration: 'Integración',
      integrationSubtitle:
        'Integración fluida para obtener información de rendimiento en tiempo real',
      customer: 'Cliente',
      accessibleCustomersError: 'Error al obtener clientes accesibles',
      workflows: 'Flujos de trabajo (legado)',
      apiCredentials: 'Credenciales API',
      integrationsTab: 'Flujos de trabajo',
      noSubscription:
        'No se encontró ninguna suscripción activa. Por favor, suscríbase para acceder a esta característica.',
      loading: 'Cargando...',
      licenseManagement: 'Gestión de licencias',
      activityLogTitle: 'Registros de actividad',
      activityLogSubtitle:
        'Seguimiento de eventos de flujo de trabajo y actualizaciones de estado de los clientes seleccionados',
      activityLogSidebarTitle: 'Registros de actividad',
      activityLogSidebarSubtitle:
        'Aquí tienes los datos de actividad de todas las organizaciones de tus clientes.',
      activityLogListTitle: 'Lista de actividades',
      activityLogSearchPlaceholder: 'Buscar por actividad, sitio',
      activityLogLastUpdated: 'Última actualización',
      activityLogCreatedOn: 'Creado el',
      activityLogActivity: 'Actividad',
      activityLogSite: 'Sitio',
      activityLogStatus: 'Estado',
      activityLogCreatedBy: 'Creado por',
      activityLogUpdatedBy: 'Actualizado por',
      activityLogNameUnavailable: 'Nombre no disponible',
      activityLogUserNamesError:
        'Error al cargar los nombres de CreatedBy / UpdatedBy',
      activityLogStatusSuccess: 'Éxito',
      activityLogStatusFailed: 'Error',
      activityLogStatusInProgress: 'En progreso',
      activityLogStatusQueued: 'En cola',
      activityLogStatusPending: 'Pendiente',
      activityLogStatusSkipped: 'Omitido',
      activityLogPaginationInfo:
        '{startItem} - {endItem} de {totalItems} artículos',
      activityLogPageGoTo: 'Ir a la página',
      activityLogRowPerPage: 'Filas por página',
      activityLogRetry: 'Reintentar',
      activityLogRetrying: 'Reintentando...',
      activityLogRetrySuccess: 'Reintento de tarea iniciado con éxito.',
      activityLogRetryError:
        'Error al reintentar la tarea. Por favor, inténtalo de nuevo.',
      activityLogRetryAllSuccess: 'Todas las tareas se reintentaron con éxito.',
      activityLogRetryAllFailed:
        'Todos los intentos de reintento fallaron. Por favor, inténtelo de nuevo.',
      activityLogRetryPartialFailed:
        'Fallaron los reintentos de algunas tareas. Por favor, inténtalo de nuevo.',
      activityLogLoading: 'Cargando detalles...',
      activityLogFetchError:
        'No se han cargado los datos de actividad. Por favor, inténtalo de nuevo.',
      activityLogModalClose: 'Cerrar',
      activityLogModalTasks: 'Tareas',
      activityLogModalCreatedOn: 'Creado el',
      activityLogModalLastUpdatedOn: 'Última actualización el',
      activityLogModalSupportNote:
        'Descripción acerca del evento de falla y el código de causa.',
      activityLogModalSupportReach: 'Para recibir ayuda, contacte a',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filtrar por',
      noCustomersAvailable: 'No hay clientes disponibles',
      activityLogFilterStatus: 'Estado',
      activityLogFilterActivity: 'Actividad',
      activityLogFilterSite: 'Sitio',
      activityLogFilterCreatedBy: 'Creado por',
      activityLogFilterApply: 'Aplicar',
      activityLogFilterReset: 'Restablecer',
      activityLogFilterNoOptions: 'No hay opciones disponibles',
      activityLogFilterError:
        'No se han cargado las opciones de filtro. Por favor, inténtalo de nuevo.',
      search: 'Buscar',
      more: 'más',
      noResults: 'No se encontraron resultados',
      activityLogCustomizeColumns: 'Personalizar columnas',
      activityLogColumnsReorder: 'Reordenar',
      activityLogColumnsAddRemove: 'Añadir/Eliminar',
      activityLogColumnsReorderDescription:
        'Reorganizar para cambiar el orden de las columnas de la tabla',
      activityLogColumnsAddRemoveDescription:
        'Marque las columnas para mostrarlas en la tabla',
      activityLogDetails: 'Detalles',
      activityLogFiltersChanged:
        'No se encontraron datos para los filtros seleccionados. Modifique o restablezca los filtros para ver resultados.',
      activityLogResetFilters: 'Restablecer filtros',
      activityLogSiteState: 'Estado',
      activityLogSiteCity: 'Ciudad',
      workflowTaskCBCustomerCreation: 'Creación de Cliente CB',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        'Actualización del estado de incorporación en el portal de socios',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'Actualizar el ID de cliente de CB en el portal de socios',
      workflowTaskEOMCustomerCreation: 'Creación de Cliente EOM',
      workflowTaskOnboardCustomerForAI: 'Incorporar cliente para IA',
      workflowTaskDeleteCustomerInCBPortal: 'Eliminar cliente en el portal CB',
      workflowTaskUpdateCustomerInCBPortal:
        'Actualizar el cliente en el portal CB',
      workflowTaskUpdateCustomerInEOM: 'Actualizar el cliente en EOM',
      workflowTaskUpdateCustomerInAssetModelling:
        'Actualizar el cliente en modelado de activos',
      workflowTaskTrackScanStatusFileAttachment:
        'Rastrear el estado de escaneo del archivo adjunto',
      workflowTaskCBSiteCreation: 'Creación de sitio CB',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        'Actualizar el ID del sitio CB en el portal de socios',
      workflowTaskEOMSiteCreation: 'Creación de sitio EOM',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        'Actualizar el ID del sitio de EOM en el portal de socios',
      workflowTaskSyncExistingUsersCBPortal:
        'Sincronizar usuarios existentes con CB Portal',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Actualizar el estado de sincronización de usuario en el portal de socios',
      workflowTaskCalculateEnergySavingsPotential:
        'Calcular el potencial de ahorro energético',
      workflowTaskDeleteSiteInCBPortal: 'Eliminar sitio en el portal CB',
      workflowTaskDeleteSiteInEOM: 'Eliminar sitio en EOM',
      workflowTaskUpdateSiteInCBPortal: 'Actualizar el sitio en el portal CB',
      workflowTaskUpdateSiteInEOM: 'Actualizar el sitio en EOM',
      workflowTaskUpdateSiteInAssetModelling:
        'Actualizar sitio en modelado de activos',
      workflowTaskUpdateSiteInFindAPI: 'Actualizar el sitio en Buscar API',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Sincronizar la asociación de suscripción con CB Portal',
      workflowTaskEnableBrickOntology: 'Habilitar la ontología Brick',
      workflowTaskOnboardCustomerForgeAPI: 'Incorporar cliente en ForgeAPI',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'Publicar el estado de integración de ForgeAPI en Gestión de Credenciales',
      workflowTaskAddUserInCBPortal: 'Agregar usuario en el portal CB',
      workflowTaskUpdateUserProvisioningStatus:
        'Actualizar el estado de aprovisionamiento de usuario',
      workflowTaskDeleteUserInCBPortal: 'Eliminar usuario en el portal CB',
      workflowTaskUpdateUserDeletionStatus:
        'Actualizar el estado de eliminación de usuarios',
      workflowCustomerCreation: 'Creación de cliente',
      workflowCustomerDelete: 'Eliminación de cliente',
      workflowCustomerUpdate: 'Actualización de cliente',
      workflowFileAttachmentsScan: 'Estado del escaneo de archivos adjuntos',
      workflowSiteCreation: 'Creación de sitio',
      workflowSiteDelete: 'Eliminar sitio',
      workflowSiteUpdate: 'Actualización del sitio',
      workflowSubscriptionAssociation: 'Asociación de suscripción',
      workflowAddUser: 'Agregar usuario',
      workflowDeleteUser: 'Eliminar usuario',
      workflowNamePlate: 'Placa de identificación',
      workflowForgeAPIOnboarding: 'Incorporación de Forge API',
      workflowAddUserMultiple: 'Flujo de trabajo para agregar usuario Múltiple',
      workflowDeleteUserMultiple:
        'Flujo de trabajo para eliminar usuario Múltiple',
      workflowModelFileUpload: 'Subir archivo de modelo',
      workflowGatewayAssociation: 'Asociación de la puerta de enlace',
      workflowIntegrationRegistered: 'Integración registrada',
      workflowTaskForgeAPIOnboardingStatus:
        'Estado de la Incorporación de Forge API',
      workflowTaskAddUser: 'Flujo de trabajo para agregar usuario',
      workflowTaskProcessModelFile: 'Procesar archivo de modelo',
      workflowTaskNotifyAssetModelling: 'Notificar modelado de activos',
      workflowTaskAssociateGateway: 'Asociar pasarela a sitio',
      workflowTaskFetchModelToAssetModelling:
        'Importar modelo al modelado de activos',
      workflowTaskNameProcessNamePlate:
        'Procesar archivo de placa de características.',
      workflowTaskUpdateModelInFindAPI: 'Actualizar modelo en Find API',
      workflowTaskProcessIntegrationRegistered: 'Integración registrada',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'Procesar notificación DF para integración registrada',
      workflowTaskTenantOnboardingAFO: 'Incorporación del inquilino a AFO',
      workflowTaskOnboardCustomerCDL: 'Incorporar cliente para CDL',
      workflowTaskPublishAFOOnboardingStatus: 'Publicar el estado de incorporación a AFO en el servicio Rule Builder',
      activityLogCorrelationId: 'ID de correlación',
      activityLogTaskId: 'ID de tarea',
      activityLogToastSuccess: 'Éxito',
      activityLogToastError: 'Error',
      activityLogIteration: 'Iteración',
      activityLogFieldFirstName: 'Nombre',
      activityLogFieldLastName: 'Apellido',
      activityLogFieldSubscriptionName: 'Nombre de la suscripción',
      activityLogFieldName: 'Nombre',
      activityLogFieldCurrency: 'Divisa',
      activityLogFieldZip: 'Código postal',
      activityLogFieldArea: 'Área',
      activityLogFieldCity: 'Ciudad',
      activityLogFieldState: 'Estado',
      activityLogFieldCountry: 'País',
      activityLogFieldAreaUnit: 'Unidad de área',
      activityLogFieldLanguage: 'Idioma',
      activityLogFieldLatitude: 'Latitud',
      activityLogFieldSiteType: 'Tipo de sitio',
      activityLogFieldTimezone: 'Zona horaria',
      activityLogFieldLongitude: 'Longitud',
      activityLogFieldCountryCode: 'Código de país',
      activityLogFieldSiteId: 'ID del sitio',
      activityLogFieldFileType: 'Tipo de archivo',
      activityLogFieldReason: 'Motivo',
      activityLogFieldCustomerSupportEmails: 'Correos electrónicos de atención al cliente',
      activityLogFieldAddressLine1: 'Línea de dirección 1',
      activityLogFieldAddressLine2: 'Línea de dirección 2',
      activityLogFieldContactEmail: 'Correo electrónico de contacto',
      activityLogSiTitle: 'Registro de actividad',
      support: 'Soporte',
      projectManagement: 'Gestión de proyectos',
    }
  }
};
